import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Store} from '@ngxs/store';
import {AuthService} from '../../../auth.service';
import {AuthState} from '../../../shared/states/AuthState';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, of, Subscription} from 'rxjs';
import {catchError, debounceTime, map, startWith, switchMap, tap} from 'rxjs/operators';
import {FormControl} from '@angular/forms';
import {WhistlerAPIService} from '../../../whistler-api.service';

@Component({
    selector: 'app-home',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss']
})
export class UsersComponent implements AfterViewInit, OnInit, OnDestroy {

    formControl = new FormControl();
    filter: string;

    displayedColumns: string[] = ['id', 'name', 'avatar', 'email', 'desc', 'created_at', 'nsfw'];
    length: number;
    limit: number;
    dataSource = [];

    isLoadingResults = true;
    error = false;

    private sort$: Subscription;
    private dataSource$: Subscription;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private readonly whistlerAPIService: WhistlerAPIService
    ) {

    }

    ngOnInit(): void {

    }

    async ngAfterViewInit(): Promise<void> {
        this.sort$ = this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

        const filterObs = this.formControl.valueChanges
            .pipe(
                debounceTime(500),
                tap(filter => {
                    this.paginator.pageIndex = 0;
                    this.filter = filter;
                })
            );

        this.dataSource$ = merge(this.sort.sortChange, this.paginator.page, filterObs)
            .pipe(
                startWith({}),
                switchMap(async () => {
                    this.isLoadingResults = true;
                    this.error = false;

                    return await this.whistlerAPIService.getUsers(this.paginator.pageIndex, this.sort.direction, this.filter);
                }),
                map(res => {
                    this.isLoadingResults = false;
                    this.length = res.data.length;
                    this.limit = res.data.limit;

                    return res.data.content;
                }),
                catchError(() => {
                    this.isLoadingResults = false;
                    this.error = true;

                    return of([]);
                })
            ).subscribe(data => this.dataSource = data);
    }

    ngOnDestroy(): void {
        this.dataSource$.unsubscribe();
        this.sort$.unsubscribe();
    }

}
